"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashedUinfinAgency = void 0;
var HashedUinfinAgency;
(function (HashedUinfinAgency) {
    HashedUinfinAgency["MND_ONE_SERVICE"] = "MND_ONE_SERVICE";
    HashedUinfinAgency["GOV_WALLET_NS"] = "GOV_WALLET_NS";
    HashedUinfinAgency["GOV_WALLET_FOOD_CONNECT"] = "GOV_WALLET_FOOD_CONNECT";
    HashedUinfinAgency["GOV_WALLET_SSG"] = "GOV_WALLET_SSG";
    HashedUinfinAgency["GOV_WALLET_MOH"] = "GOV_WALLET_MOH";
    HashedUinfinAgency["STATEMENT_OF_BENEFITS"] = "STATEMENT_OF_BENEFITS";
    HashedUinfinAgency["NSPE_MINDEF"] = "NSPE_MINDEF";
    HashedUinfinAgency["CCUBE_DEMO"] = "CCUBE_DEMO";
})(HashedUinfinAgency || (exports.HashedUinfinAgency = HashedUinfinAgency = {}));
//# sourceMappingURL=hashed-uinfin-agency.js.map